module.exports = __webpack_public_path__ + "img/main-h5.dcca13b4.png";